import { Breakpoint, Grid } from 'antd';
import { AxiosResponse } from 'axios';
import { Dispatch, SetStateAction, createContext, useState } from 'react';
import { ITicket } from 'src/types/helpdesk/ticket.type';

const { useBreakpoint } = Grid;

interface TicketDetailContextInterface {
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  ticket: AxiosResponse<ITicket, any> | undefined;
  setTicket: Dispatch<SetStateAction<AxiosResponse<ITicket, any> | undefined>>;
  overtimeRelativeCount: number | undefined;
  setOvertimeRelativeCount: Dispatch<SetStateAction<number | undefined>>;
  screens: Partial<Record<Breakpoint, boolean>> | undefined;
  // isViewDetailTicketSolution: boolean;
  // isViewDetailOvertimeTicket: boolean;
  // isViewDetailAdvancePaymentTicket: boolean;
  // isViewDetailBusinessTripTicket: boolean;
  // isViewDetailTicket: boolean;
  // isViewDetailPurchaseRequestTicket: boolean;
  // isAdmin: boolean;
}

const initialTicketDetailContext: TicketDetailContextInterface = {
  loading: true,
  setLoading: () => null,
  ticket: undefined,
  setTicket: () => null,
  overtimeRelativeCount: undefined,
  setOvertimeRelativeCount: () => null,
  screens: undefined
  // isViewDetailTicketSolution: false,
  // isViewDetailOvertimeTicket: false,
  // isViewDetailAdvancePaymentTicket: false,
  // isViewDetailBusinessTripTicket: false,
  // isViewDetailTicket: false,
  // isViewDetailPurchaseRequestTicket: false,
  // isAdmin: false
};

export const TicketDetailContext = createContext<TicketDetailContextInterface>(initialTicketDetailContext);

export const TicketDetailProvider = ({ children }: { children: React.ReactNode }) => {
  const [ticket, setTicket] = useState<AxiosResponse<ITicket, any> | undefined>(initialTicketDetailContext.ticket);
  const [loading, setLoading] = useState<boolean>(true);
  const [overtimeRelativeCount, setOvertimeRelativeCount] = useState<number | undefined>(
    initialTicketDetailContext.overtimeRelativeCount
  );

  const screens = useBreakpoint();

  // const { roles } = useContext(AppContext);
  // const listPermissionTicketSolution = useMemo(() => {
  //   return getListPermission(urlPath.ticketSolution.location, roles);
  // }, [roles]);

  // const listPermissionOvertimeTicket = useMemo(() => {
  //   return getListPermission(urlPath.overtimeTicket.location, roles);
  // }, [roles]);

  // const listPermissionAdvancePaymentTicket = useMemo(() => {
  //   return getListPermission(urlPath.advancePaymentLimit.location, roles);
  // }, [roles]);

  // const listPermissionBusinessTripTicket = useMemo(() => {
  //   return getListPermission(urlPath.businessTripTicket.location, roles);
  // }, [roles]);

  // const listPermissionPurchaseRequestTicket = useMemo(() => {
  //   return getListPermission(urlPath.purchaseRequestTicket.location, roles);
  // }, [roles]);

  // const listPermissionTicket = useMemo(() => {
  //   return getListPermission(urlPath.ticket.location, roles);
  // }, [roles]);

  // const isViewDetailTicketSolution = listPermissionTicketSolution?.includes(PermissionEn.viewDetail);
  // const isViewDetailOvertimeTicket = listPermissionOvertimeTicket?.includes(PermissionEn.viewDetail);
  // const isViewDetailAdvancePaymentTicket = listPermissionAdvancePaymentTicket?.includes(PermissionEn.viewDetail);
  // const isViewDetailBusinessTripTicket = listPermissionBusinessTripTicket?.includes(PermissionEn.viewDetail);
  // const isViewDetailTicket = listPermissionTicket?.includes(PermissionEn.viewDetail);
  // const isViewDetailPurchaseRequestTicket = listPermissionPurchaseRequestTicket?.includes(PermissionEn.viewDetail);
  // const isAdmin = listPermissionTicket?.includes(PermissionEn.admin);
  return (
    <TicketDetailContext.Provider
      value={{
        loading,
        setLoading,
        ticket,
        setTicket,
        overtimeRelativeCount,
        setOvertimeRelativeCount,
        screens
        // isViewDetailTicketSolution,
        // isViewDetailOvertimeTicket,
        // isViewDetailAdvancePaymentTicket,
        // isViewDetailBusinessTripTicket,
        // isViewDetailTicket,
        // isViewDetailPurchaseRequestTicket,
        // isAdmin
      }}
    >
      {children}
    </TicketDetailContext.Provider>
  );
};
